require('./home-vod-slider');
require('./home-magazine');
require('../vod/player-overlay');
require('./homepage-sport1-plus');

jQuery(document).ready(($) => {

    const $mainGallery = $('.sport1-main-article-gallery');

    if ($mainGallery.length) {
        const title = $('.sport1-post-entry-details .title', $mainGallery).get(0);
        const titleTop = title.offsetParent.offsetTop;
        $('.main-gallery-dots').css('top', `${titleTop - 9}px`);

        const galleySliderOptions = {
            'slidesToShow': 1,
            'slidesToScroll': 1,
            'infinite': true,
            'autoplay': true,
            'autoplaySpeed': 4000,
            'rtl': true,
            'dots': true,
            'appendDots': '.main-gallery-dots',
            'lazyLoad': 'ondemand',
            'mobileFirst': true,
            'arrows': false,
            'draggable': true,
            'responsive':
                [
                    {
                        'breakpoint':
                            767,
                        'settings':
                            {
                                'nextArrow': '<img class="next" src="/app/themes/sport1/public/images/left-arrow.svg">',
                                'prevArrow': '<img class="prev" src="/app/themes/sport1/public/images/right-arrow.svg">',
                                'dots': false,
                                'arrows': true,
                            }
                    }
                ]
        };

        const $slider = $('.post-gallery', $mainGallery);

        $slider.slick(galleySliderOptions);

        $('.slick-arrow', $slider).on('click', (e) => {
            e.stopPropagation();
            e.preventDefault();

            return false;
        });
    }

    /**
     * main article click
     * */
    $('.main-article-wrapper a').on('click', function () {
        let label = $('.sport1-post-entry-title', this).text();
        sport1Analytics.sendEvent('desktop-home-page', 'main-article-click', label);
    });

    /**
     * desktop 3 sub main articles click (below sport 1+)
     * */
    $('.homepage-section-main .hot-news-container a.image-wrapper').on('click', function () {
        let label = $('.article-card-title', this).text();
        sport1Analytics.sendEvent('desktop-home-page', 'side-article-click', label);
    });

    /**
     * sport 1+ cta click
     * */
    $('.homepage-section-main .sport1-plus-empty button[data-target="#login-modal"]').on('click', function () {
        sport1Analytics.sendEvent('desktop-home-page', 'click', 'what-interests-you');
    });

    /**
     * hot new item click (main)
     * */
    $('.hot-news-items .big-article a').on('click', function () {
        let label = $('.sport1-post-entry-title', this).text();
        sport1Analytics.sendEvent('desktop-home-page', 'main-news-click', label);
    });

    /**
     * hot new item click (not main)
     * */
    $('.hot-news-items .medium-article a, .hot-news-items .small-article a').on('click', function () {
        let label = $('.sport1-post-entry-title', this).text();
        sport1Analytics.sendEvent('desktop-home-page', 'news-click', label);
    });

    /**
     * category article link click
     * */
    $('.category-items a.image-wrapper').on('click', function () {

        let category = $(this).closest('.homepage-section-category');
        let categorySlug = getCategorySlug(category);

        let action = `${categorySlug}-click`;

        let label = $('.article-card-title', this).text();
        sport1Analytics.sendEvent('desktop-home-page', action, label);
    });

    /**
     * 'view all' category link click
     * */
    $('.homepage-section-category .view-all').on('click', function () {
        let category = $(this).closest('.homepage-section-category');
        let categorySlug = getCategorySlug(category);
        let action = `all-${categorySlug}-click`;
        let label = `int ${categorySlug}`;
        sport1Analytics.sendEvent('desktop-home-page', action, label);
    });

});

function getCategorySlug(categorySection) {
    let categoryLink = $('.view-all', categorySection);
    let categorySlug = categoryLink.attr('href').replace(location.host, '').replace(location.protocol + '//', '').replace('category', '');
    categorySlug = categorySlug.replace(/\//g, '');

    return categorySlug;
}
